import { Check, Minus } from "lucide-react";
import { COMPARE } from "./data/content";
import Reveal from "./Reveal";

export const Compare = () => (
  <section id="compare" className="py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="label-mono">The honest comparison</p>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Three ways to run your agency.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-12 overflow-x-auto" data-testid="comparison-table">
          <div className="min-w-[760px]">
            {/* header row */}
            <div className="grid grid-cols-[1.1fr_1fr_1fr_1.15fr]">
              <div />
              {COMPARE.columns.map((c, i) => (
                <div
                  key={c}
                  className={`rounded-t-2xl border px-5 py-5 ${
                    i === 2
                      ? "border-gold/50 bg-gold/10"
                      : "border-white/10 bg-panel/40"
                  } ${i === 2 ? "" : "border-b-0"}`}
                >
                  <p className={`font-display text-base font-bold tracking-tight ${i === 2 ? "text-gold-light" : "text-slate-300"}`}>
                    {c}
                  </p>
                  {i === 2 && <p className="label-mono mt-1.5 !text-[10px]">The Agency HQ way</p>}
                </div>
              ))}
            </div>
            {/* body rows */}
            {COMPARE.rows.map((row, r) => (
              <div
                key={row.label}
                className={`grid grid-cols-[1.1fr_1fr_1fr_1.15fr] ${r % 2 ? "bg-white/[0.015]" : ""}`}
              >
                <div className="flex items-center px-5 py-4 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">
                  {row.label}
                </div>
                {row.values.map((v, i) => (
                  <div
                    key={i}
                    className={`flex items-center gap-2.5 px-5 py-4 text-sm leading-snug ${
                      i === 2
                        ? "border-x border-gold/30 bg-gold/[0.06] font-medium text-white"
                        : "text-slate-400"
                    } ${r === COMPARE.rows.length - 1 && i === 2 ? "rounded-b-2xl border-b border-gold/50 bg-gold/10" : ""}`}
                  >
                    {i === 2 ? (
                      <Check className="h-4 w-4 shrink-0 text-gold-light" />
                    ) : (
                      <Minus className="h-4 w-4 shrink-0 text-slate-600" />
                    )}
                    {v}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-6 text-xs text-slate-500">
          Commission retention figures are indicative of common market structures; your exact numbers are
          confirmed confidentially before you join.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Compare;
